export default __webpack_public_path__ + "static/media/80.1373b37b.png";